import { render, staticRenderFns } from "./WikiText.vue?vue&type=template&id=adf1be70"
import script from "./WikiText.vue?vue&type=script&lang=js"
export * from "./WikiText.vue?vue&type=script&lang=js"
import style0 from "./WikiText.vue?vue&type=style&index=0&id=adf1be70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports